/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* eslint no-use-before-define: ["error", { "functions": false }] */

import agentsAPI from '@api/agents';
import {
  agentsRequest,
  agentsFailure,
  addAgentSuccess,
  getAgentsSuccess,
  getAgentSuccess,
  getAgentTrainSuccess,
  startAgentTrainSuccess,
  getAgentUpdatesSuccess,
  getLastModelAnalyzerReportSuccess,
  startModelAnalysisSuccess,
  agentBotSubscriptionRequest,
  getAgentBotSubscriptionSuccess,
} from '@store/reducers/agents';

import { errorAlert } from '@store/reducers/alerts';
import { idField } from '@constants';
import { subscribeToEvent } from '@components/websocket/webSocketAPI';

function getAgents() {
  return dispatch => {
    dispatch(agentsRequest());
    agentsAPI
      .getAgents()
      .then(response => {
        dispatch(getAgentsSuccess(response.data));

        if (response.data && response.data.length) {
          const agent = response.data[0];
          const agentId = agent[idField];
          dispatch(agentBotSubscriptionRequest());
          agentsAPI
            .getAgentBotSubscription(agentId)
            .then(subscriptionResponse => {
              dispatch(getAgentBotSubscriptionSuccess(subscriptionResponse.data));
            })
            .catch(error => {
              handleError(dispatch, error);
            });
        }
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function addAgent(agent) {
  return dispatch => {
    dispatch(agentsRequest());
    agentsAPI
      .addAgent(agent)
      .then(response => {
        dispatch(addAgentSuccess(response.data));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function getAgent(agentId) {
  return dispatch => {
    dispatch(agentsRequest());
    agentsAPI
      .getAgent(agentId)
      .then(response => {
        dispatch(getAgentSuccess(response.data));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function getAgentTrain(agentId) {
  return dispatch => {
    agentsAPI
      .getAgentTrain(agentId)
      .then(response => {
        dispatch(getAgentTrainSuccess(response.data));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function startAgentTrain(agentId, versionId, includeAnalysis) {
  return dispatch => {
    agentsAPI
      .startAgentTrain(agentId, versionId, includeAnalysis)
      .then(response => {
        dispatch(startAgentTrainSuccess(response.data));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function getLastModelAnalyzerReport(agentId, versionId = '') {
  return dispatch => {
    agentsAPI
      .getLastModelAnalyzerReport(agentId, versionId)
      .then(response => {
        dispatch(getLastModelAnalyzerReportSuccess(response.data));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function startModelAnalysis(agentId, versionId) {
  return dispatch => {
    agentsAPI
      .startModelAnalysis(agentId, versionId)
      .then(response => {
        dispatch(startModelAnalysisSuccess(response.data));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function getAgentUpdates(agentId) {
  return dispatch => {
    agentsAPI
      .getAgentUpdates(agentId)
      .then(response => {
        dispatch(getAgentUpdatesSuccess(response.data));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function handleError(dispatch, error) {
  dispatch(agentsFailure(error.message));
  dispatch(errorAlert((error.response && error.response.data) || error.message));
}

function getAgentUpdatesWS(socket) {
  return dispatch => {
    subscribeToEvent(socket, 'UPDATES', msg => {
      dispatch(getAgentUpdatesSuccess(msg.updates));
    });
  };
}

export default {
  getAgents,
  addAgent,
  getAgent,
  getAgentTrain,
  startAgentTrain,
  getAgentUpdates,
  getAgentUpdatesWS,
  getLastModelAnalyzerReport,
  startModelAnalysis,
};
